import { useState } from "react";
import { apiWithoutCamelization } from "../api";
import { mieterstromInvoicingApiWithoutCamelization } from "../api/subApis/mieterstromInvoicingApi";
import { useToast } from "../mantine/notifications/useToast";
import type { components } from "../types/api.types";
import urls from "../urls";
import { pollTaskStatus } from "../utils/api-utils";
import { downloadPDF } from "../utils/downloadPdf";

type JobStatus = components["schemas"]["JobStatus"];

function useSapExport() {
  const { showToast, showErrorToast } = useToast();
  const [exportLoading, setExportLoading] = useState(false);

  function getExportFromBackend(projectId: string, taskId: string) {
    apiWithoutCamelization
      .get(
        mieterstromInvoicingApiWithoutCamelization.invoiceExportResult.url({
          projectId,
          taskId
        })
      )
      .then((r) => {
        downloadPDF(r);
        showToast({
          type: "success",
          message: "Export erfolgreich heruntergeladen."
        });
      })
      .catch((error) => {
        showErrorToast(error);
      })
      .finally(() => {
        setExportLoading(false);
      });
  }

  function generateAndDownloadSapExport(
    projectId: string,
    dateFrom: string,
    dateTo: string,
    supplierId?: string
  ) {
    if (!projectId || !dateFrom || !dateTo) return Promise.reject();
    setExportLoading(true);
    return apiWithoutCamelization
      .get<JobStatus>(
        mieterstromInvoicingApiWithoutCamelization.invoiceExportGenerate.url({
          projectId,
          dateFrom,
          dateTo,
          supplierId
        })
      )
      .then((response) => {
        if (
          response.data &&
          response.data.task_ids &&
          response.data.task_ids[0]
        ) {
          const taskId: string = response.data.task_ids[0];
          pollTaskStatus(
            urls.api.jobStatus(taskId),
            () => getExportFromBackend(projectId, taskId),
            (error) => {
              setExportLoading(false);
              showErrorToast(error);
            }
          );
        } else {
          setExportLoading(false);
        }
      })
      .catch((error) => {
        setExportLoading(false);
        showErrorToast(error);
      });
  }

  return { generateAndDownloadSapExport, exportLoading };
}

export { useSapExport };
